import { toast } from "sonner";

// Lot 620 — profil incomplet : quand une action est refusée (403 profile_incomplete, ou garde côté client), la feuille
// « Complète ton profil pour interagir » s'ouvre tout de suite. Aucun toast d'erreur rouge ne doit la doubler : les
// 600+ appels `toast.error(asError(e))` de l'app sont neutralisés pendant une courte fenêtre après l'ouverture.
const WINDOW_MS = 2500;
let gateTs = 0;

export const profileGateJustOpened = () => Date.now() - gateTs < WINDOW_MS;

export const installProfileGateToastFilter = () => {
  if (typeof window === "undefined" || toast.__profileGateFiltered) return;
  window.addEventListener("yalola:profile_incomplete", () => { gateTs = Date.now(); });
  const origError = toast.error;
  toast.error = (...args) => (profileGateJustOpened() ? undefined : origError(...args));
  toast.__profileGateFiltered = true;
};
